export function quoteMeiliString(value: string) {
  return `"${value.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
}

export function buildNeedsAnchorFilter(validSituationIds: string[]) {
  if (validSituationIds.length === 0) {
    return "";
  }

  const validSituationIdsFilter = validSituationIds
    .map(quoteMeiliString)
    .join(", ");

  return [
    "situation_id IS NULL",
    "situation_id IS EMPTY",
    "situation_id NOT EXISTS",
    `situation_id NOT IN [${validSituationIdsFilter}]`,
  ].join(" OR ");
}
